import { render, staticRenderFns } from "./ComposeMessage.vue?vue&type=template&id=2f8ea160&scoped=true&"
import script from "./ComposeMessage.vue?vue&type=script&lang=js&"
export * from "./ComposeMessage.vue?vue&type=script&lang=js&"
import style0 from "./ComposeMessage.vue?vue&type=style&index=0&id=2f8ea160&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ea160",
  null
  
)

export default component.exports